import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function LegalPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 font-sans text-white">
      {/* ヘッダー */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-slate-950/80 backdrop-blur-xl border-b border-cyan-500/20 shadow-lg shadow-cyan-500/10' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center">
              <h1 className="text-2xl font-bold bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent">
                空間Lab AI研修
              </h1>
            </Link>

            <div className="hidden lg:block">
              <Link to="/" className="text-gray-300 hover:text-cyan-400 transition-all duration-300 text-sm font-medium whitespace-nowrap">
                トップページへ戻る
              </Link>
            </div>

            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden text-gray-300 cursor-pointer">
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="lg:hidden bg-slate-950/95 backdrop-blur-xl border-t border-cyan-500/20">
            <div className="px-4 py-4">
              <Link to="/" className="block w-full text-left text-gray-300 hover:text-cyan-400 py-2 transition-colors">
                トップページへ戻る
              </Link>
            </div>
          </div>
        )}
      </header>

      {/* メインコンテンツ */}
      <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl sm:text-5xl font-bold mb-4">
              <span className="bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
                特定商取引法に基づく表記
              </span>
            </h1>
            <p className="text-gray-400">最終更新日：2025年1月1日</p>
          </div>

          <div className="bg-slate-900/50 backdrop-blur-sm border border-cyan-500/20 rounded-3xl p-8 space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-building-line text-cyan-400"></i>
                </div>
                事業者情報
              </h2>
              <div className="bg-slate-800/50 border border-cyan-500/20 rounded-2xl p-6 space-y-3 text-gray-300">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                  <div className="font-semibold text-white">事業者名</div>
                  <div className="sm:col-span-2">株式会社 空間Lab</div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                  <div className="font-semibold text-white">代表者</div>
                  <div className="sm:col-span-2">代表取締役</div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                  <div className="font-semibold text-white">所在地</div>
                  <div className="sm:col-span-2">大阪府</div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                  <div className="font-semibold text-white">ウェブサイト</div>
                  <div className="sm:col-span-2">
                    <a href="https://kukan-lab.com/" target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:text-cyan-300 transition-colors">
                      https://kukan-lab.com/
                    </a>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-service-line text-cyan-400"></i>
                </div>
                販売価格
              </h2>
              <div className="bg-slate-800/50 border border-cyan-500/20 rounded-2xl p-6">
                <div className="space-y-4 text-gray-300">
                  <div className="flex justify-between items-center pb-4 border-b border-cyan-500/20">
                    <div>
                      <div className="font-semibold text-white text-lg">AIマンツーマン研修（3時間）</div>
                      <div className="text-sm text-gray-400 mt-1">ChatGPT/Gemini実践研修</div>
                    </div>
                    <div className="text-right">
                      <div className="text-3xl font-bold text-cyan-400">280,000円</div>
                      <div className="text-sm text-gray-400">（税込）</div>
                    </div>
                  </div>
                  <p className="text-sm text-gray-400">
                    ※先着20名限定価格です。通常価格は450,000円（税込）となります。<br />
                    ※価格は予告なく変更する場合がございます。
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-bank-card-line text-cyan-400"></i>
                </div>
                支払方法
              </h2>
              <div className="space-y-3 text-gray-300">
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <div>
                    <div className="font-semibold text-white">銀行振込</div>
                    <div className="text-sm text-gray-400 mt-1">お申し込み後、指定の口座へお振込みください。振込手数料はお客様負担となります。</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <div>
                    <div className="font-semibold text-white">クレジットカード決済</div>
                    <div className="text-sm text-gray-400 mt-1">VISA、MasterCard、JCB、American Express、Diners Clubがご利用いただけます。</div>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-calendar-check-line text-cyan-400"></i>
                </div>
                支払時期
              </h2>
              <p className="text-gray-300 leading-relaxed">
                お申し込み確定後、7日以内にお支払いをお願いいたします。お支払いの確認後、研修日程を確定させていただきます。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-truck-line text-cyan-400"></i>
                </div>
                サービス提供時期
              </h2>
              <p className="text-gray-300 leading-relaxed">
                お支払い確認後、お客様と調整の上、研修日程を確定いたします。通常、お申し込みから2週間〜1ヶ月以内に実施いたします。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-arrow-go-back-line text-cyan-400"></i>
                </div>
                キャンセル・返金ポリシー
              </h2>
              <div className="bg-slate-800/50 border border-cyan-500/20 rounded-2xl p-6 space-y-4">
                <div className="space-y-3 text-gray-300">
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                    <div>
                      <div className="font-semibold text-white">研修開催日の7日前まで</div>
                      <div className="text-sm text-gray-400 mt-1">全額返金いたします（振込手数料を差し引いた金額）</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                    <div>
                      <div className="font-semibold text-white">研修開催日の3日前まで</div>
                      <div className="text-sm text-gray-400 mt-1">50%返金いたします（振込手数料を差し引いた金額）</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-close-line text-red-400 mt-1 flex-shrink-0"></i>
                    <div>
                      <div className="font-semibold text-white">研修開催日の2日前以降</div>
                      <div className="text-sm text-gray-400 mt-1">返金不可となります</div>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-gray-400 pt-4 border-t border-cyan-500/20">
                  ※やむを得ない事情によるキャンセルの場合は、日程変更にて対応させていただきます。<br />
                  ※当社都合によるキャンセルの場合は、全額返金いたします。
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-shield-check-line text-cyan-400"></i>
                </div>
                補講保証について
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                研修内容の理解が難しかった場合、後日1時間程度のフォローアップを無料で実施いたします。以下の条件に該当する場合にご利用いただけます：
              </p>
              <ul className="space-y-2 text-gray-300">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>研修終了後、1ヶ月以内にお申し出いただいた場合</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>研修内容の理解が不十分であると当社が判断した場合</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>補講は1回限りとさせていただきます</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-file-text-line text-cyan-400"></i>
                </div>
                その他の費用
              </h2>
              <p className="text-gray-300 leading-relaxed">
                研修料金以外に、以下の費用が発生する場合がございます：
              </p>
              <ul className="space-y-2 text-gray-300 mt-4">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>銀行振込手数料（お客様負担）</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>対面研修をご希望の場合の交通費・会場費（別途お見積り）</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-cyan-400 mt-1 flex-shrink-0"></i>
                  <span>ChatGPT/Geminiの有料プラン利用料（お客様ご自身でのご契約）</span>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-mail-line text-cyan-400"></i>
                </div>
                お問い合わせ
              </h2>
              <div className="bg-slate-800/50 border border-cyan-500/20 rounded-2xl p-6">
                <p className="text-gray-300 leading-relaxed mb-4">
                  特定商取引法に関するお問い合わせは、以下までご連絡ください：
                </p>
                <div className="space-y-2 text-gray-300">
                  <p><strong className="text-white">株式会社 空間Lab</strong></p>
                  <p>ウェブサイト：<a href="https://kukan-lab.com/" target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:text-cyan-300 transition-colors">https://kukan-lab.com/</a></p>
                  <p className="text-sm text-gray-400 mt-4">※お問い合わせは、トップページのお問い合わせフォームからもご利用いただけます</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg flex items-center justify-center">
                  <i className="ri-information-line text-cyan-400"></i>
                </div>
                免責事項
              </h2>
              <p className="text-gray-300 leading-relaxed">
                当研修は、AI活用スキルの習得を目的としたものであり、特定の成果や効果を保証するものではありません。研修内容の理解度や実務での活用度合いは、受講者様の努力や業務環境により異なります。また、ChatGPT/Geminiの仕様変更により、研修内容が一部変更となる場合がございます。
              </p>
            </section>
          </div>

          <div className="mt-12 text-center">
            <button onClick={scrollToTop} className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer">
              <i className="ri-arrow-up-line"></i>
              <span>ページトップへ戻る</span>
            </button>
          </div>
        </div>
      </main>

      {/* フッター */}
      <footer className="relative bg-slate-950 border-t border-cyan-500/20 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-gray-400 text-sm mb-2">
            &copy; 2025 株式会社 空間Lab. All rights reserved.
          </p>
          <div className="flex justify-center gap-4 text-sm">
            <Link to="/" className="text-gray-400 hover:text-cyan-400 transition-colors">
              トップページ
            </Link>
            <Link to="/privacy" className="text-gray-400 hover:text-cyan-400 transition-colors">
              プライバシーポリシー
            </Link>
            <Link to="/legal" className="text-cyan-400">
              特定商取引法
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
